import { render } from "./TablaProcesos.vue?vue&type=template&id=0eea3ba5&scoped=true"
import script from "./TablaProcesos.vue?vue&type=script&lang=js"
export * from "./TablaProcesos.vue?vue&type=script&lang=js"

import "./TablaProcesos.vue?vue&type=style&index=0&id=0eea3ba5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eea3ba5"]])

export default __exports__